import * as React from "react";
import { inject, observer } from "mobx-react";
import { AppStore } from "Stores/appStore";
import { Utils } from "../../common/utils";
import { Spinner } from "react-bootstrap";


interface MasqueradeProps {
    appStore?: AppStore
}

@inject("appStore")
@observer
export class Masquerade extends React.Component<MasqueradeProps> {

    handleClick = () => {
        this.props.appStore!.stopMasquerade();
    };

    render(){
        const masqueradeUser = Utils.getCurrentUser();
        if(!masqueradeUser || !Utils.getIsMasquerading()){
            return null;
        }
        return (
            <div className="masquerade-container">
                <div>
                    {`Logged in as ${masqueradeUser.email}`}
                </div>
                <div>
                    {this.props.appStore!.isChangingMasquerade
                        ? <Spinner animation="border"/>
                        : <a onClick={this.handleClick}>Return to Original User</a>}
                </div>
            </div>
        );
    }
}